<template>
  <v-navigation-drawer
    v-model="drawerState"
    :right="true"
    absolute
    temporary>
    <v-toolbar
      flat
      class="transparent">
      <v-list class="pa-0">
        <v-list-tile avatar>
          <v-list-tile-avatar>
            <v-icon dark>account_circle</v-icon>
          </v-list-tile-avatar>

          <v-list-tile-content>
            <v-list-tile-title>{{ userName }}</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
      </v-list>
    </v-toolbar>
    <v-list
      class="pt-0"
      dense>
      <v-divider />

      <v-list-tile @click.stop="$emit('user-logout')">
        <v-list-tile-action>
          <v-icon>exit_to_app</v-icon>
        </v-list-tile-action>

        <v-list-tile-content>
          <v-list-tile-title>Afmelden</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
export default {
  name: "UserDrawer",
  props: {
    drawer: {
      type: Boolean,
      default: false
    },
    userName: {
      type: String,
      default: "",
      required: true
    }
  },
  data() {
    return {
      drawerState: this.drawer
    };
  },
  watch: {
    drawer() {
      this.drawerState = !this.drawerState;
    }
  }
};
</script>
